module.exports = __webpack_public_path__ + "static/media/app.374ff37b.png";